import { CssBaseline } from '@material-ui/core/';
import { ThemeProvider } from '@material-ui/core/styles';
import { Suspense, lazy, useEffect } from 'react';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import MainRoute from './MainRoute';
import theme from './app/theme';
import Loading from './components/Loading';
import Notifier from './components/Notifier';
import RootModal from './components/modal/RootModal';
import InitI18n from './components/shared/InitI18n';

const NotFound = lazy(() => import('./components/NotFound'));

function App() {
  const history = useHistory();
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === '/') {
      if (window.location.hostname === 'localhost') {
        history.replace(
          `/${process.env.REACT_APP_ORG_ID}/${process.env.REACT_APP_DEFAULT_PROCEDURE_ID}/setting?lang=zh-TW`,
        );
      } else {
        history.replace('/not-found');
      }
    }
  }, [history, pathname]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Notifier />
      <RootModal />
      <Switch>
        <Route path="/:page">
          <InitI18n />
          <MainRoute />
        </Route>
        <Suspense fallback={<Loading />}>
          <Route path="*" component={NotFound} />
        </Suspense>
      </Switch>
    </ThemeProvider>
  );
}

export default App;
